import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { Metric as MetricType } from '@hud/portal-dtos/webapp-common.dto';
import Trend from '@hud/web-components/Trend/Trend';
import { formatPercentage } from '@hud/web-components/utils';

export function formatMetricTrend<TData, TValue extends MetricType>(
  cell: CellContext<TData, TValue>,
) {
  const metric: MetricType = cell.getValue();

  const x =
    metric.trend !== undefined && metric.trend !== null
      ? `${formatPercentage(metric.trend)} ${metric.symbol ?? ''}`.trim()
      : '';
  return x;
}

export default function renderMetricTrend<TData, TValue extends MetricType>(
  cell: CellContext<TData, TValue>,
) {
  const metric: MetricType = cell.getValue();
  return metric.trend !== undefined && metric.trend !== null ? (
    <Trend value={metric.trend} symbol={metric.symbol} />
  ) : null;
}
